import { IApiError } from '@/models/apiError.model';
import { FeedbackType, IFeedback } from '@/models/feedback.model';
import { IPagination } from '@/models/pagination.model';
import { TGetFeedbacksQuery } from '../helpers/types';

export const FEEDBACKS_SLICE_NAME = 'feedbacks';

export interface FeedbackListState<T = IFeedback> {
  list: T[] | null;
  isLoading: boolean;
  pagination?: IPagination | null;
  error: IApiError | null;
}

export interface FeedbacksListsState {
  [FeedbackType.CONTACT_PAGE]: FeedbackListState;
  [FeedbackType.PARTNER_SUPPORT]: FeedbackListState;
  [FeedbackType.PRODUCT_AVAILABILITY]: FeedbackListState;
  [FeedbackType.ORDER_SUPPORT]: FeedbackListState;
  [FeedbackType.POTENTIAL_PARTNER]: FeedbackListState;
  query: TGetFeedbacksQuery | null;
  newCount: number;
  newCountByType: Record<FeedbackType, number>;
  isNewCountLoading: boolean;
}

export const initialFeedbackListState: FeedbackListState = {
  list: null,
  pagination: null,
  isLoading: false,
  error: null,
};

export const initialNewCountByType: Record<FeedbackType, number> = {
  [FeedbackType.CONTACT_PAGE]: 0,
  [FeedbackType.PARTNER_SUPPORT]: 0,
  [FeedbackType.PRODUCT_AVAILABILITY]: 0,
  [FeedbackType.ORDER_SUPPORT]: 0,
  [FeedbackType.POTENTIAL_PARTNER]: 0,
};

export const initialState: FeedbacksListsState = {
  [FeedbackType.CONTACT_PAGE]: initialFeedbackListState,
  [FeedbackType.PARTNER_SUPPORT]: initialFeedbackListState,
  [FeedbackType.PRODUCT_AVAILABILITY]: initialFeedbackListState,
  [FeedbackType.ORDER_SUPPORT]: initialFeedbackListState,
  [FeedbackType.POTENTIAL_PARTNER]: initialFeedbackListState,
  query: null,
  newCount: 0,
  newCountByType: { ...initialNewCountByType },
  isNewCountLoading: false,
};
